define.alias("shared/components/shared/restricted-area/body", "calendar/components/shared/restricted-area/body");